import { FormProvider } from "react-hook-form";
import { FaCircleArrowDown, FaFileInvoiceDollar, FaMoneyBill, FaPaperclip, FaX } from "react-icons/fa6";
import CustomButton from "shared/components/button/CustomButton";
import CustomModal from "shared/components/modal/CustomModal";
import { CustomAccordionItem } from "types/accordion/CustomAccordionItemType";
import { DespesaGroupPayDetalhada } from "types/response/groupPay/DespesaGroupPayDetalhadaResponse";
import AccordionDespesa from "./cadastrarDespesa/AccordionDespesa";
import SecaoDadosDespesaModalCadastrarDespesaParcelada from "./SecaoDadosDespesaModalCadastrarDespesaParceladaGroupPay";
import SecaoRetencaoModalCadastrarDespesaGroupPay from "./SecaoRetencaoModalCadastrarDespesaGroupPay";
import { useCadastrarDespesaParceladaGroupPay } from "hooks/groupPay/useCadastrarDespesaParceladaGroupPay";
import SecaoBaixaContaPrincipal from "./SecaoBaixaContaPrincipal";
import { ValoresDespesaParceladaResponse } from "types/request/contasPagar/ValoresDespesaParceladaResponse";
import InputMultiAnexos from "shared/components/input/InputMultiAnexos";

interface ModalCadastrarDespesaParceladaGroupPayProps {
  valorTotalParcelas: number;
  showModal: boolean;
  despesaGroupPay: DespesaGroupPayDetalhada;
  parcelas: ValoresDespesaParceladaResponse[];
  onCloseModal: () => void;
  condominioId: number;
  idsDespesasAgrupadas?: number[];
}

const ModalCadastrarDespesaParceladaGroupPay: React.FC<ModalCadastrarDespesaParceladaGroupPayProps> = (props) => {
  const {
    form,
    onSubmit,
    handleCloseModal,
    fieldsClassesConta,
    adicionarClasseConta,
    removerClasseConta,
    fieldsParcelas,
    adicionarParcela,
    removerParcela,
    fieldsRetencoes,
    adicionarRetencao,
    removerRetencao,
    valorTotalBruto,
    valorTotalImpostos,
    valorTotalBrutoClassesConta,
    valorTotalParcelado,
    responseCondominioPossuiContaProvisionamento,
  } = useCadastrarDespesaParceladaGroupPay({
    ...props,
    idsDespesasAgrupadas: props.idsDespesasAgrupadas,
  });

  const { control, register, setValue, watch, clearErrors, formState } = form;

  const renderContentModalCadastrarDespesaParcelada = () => {
    const itensAccordion: CustomAccordionItem[] = [
      {
        key: "dados-despesa",
        titulo: "Dados da despesa",
        icon: <FaCircleArrowDown size={20} />,
        conteudo: (
          <SecaoDadosDespesaModalCadastrarDespesaParcelada
            watch={watch}
            control={control}
            register={register}
            setValue={setValue}
            clearErrors={clearErrors}
            classesConta={fieldsClassesConta}
            removerClasseConta={removerClasseConta}
            adicionarClasseConta={adicionarClasseConta}
            valorTotalClassesConta={valorTotalBrutoClassesConta}
            possuiContaProvisionamento={responseCondominioPossuiContaProvisionamento?.payload || false}
            condominioId={props.condominioId}
            adicionarParcela={adicionarParcela}
            parcelas={fieldsParcelas}
            valorTotalParcelas={valorTotalParcelado}
            removerParcela={removerParcela}
            valorTotalInicial={valorTotalBruto}
          />
        ),
      },
      {
        key: "retencoes",
        titulo: "Retenções",
        icon: <FaMoneyBill size={20} />,
        conteudo: (
          <SecaoRetencaoModalCadastrarDespesaGroupPay
            retencoes={fieldsRetencoes}
            adicionarRetencao={adicionarRetencao as any}
            removerRetencao={removerRetencao}
            somaValorBruto={valorTotalBruto}
            valorTotalImpostos={valorTotalImpostos}
            isParcelada={true}
            condominioId={props.condominioId}
          />
        ),
      },
      {
        key: "anexo",
        titulo: "Anexos",
        icon: <FaPaperclip size={20} />,
        conteudo: (
          <InputMultiAnexos
            name="anexos"
            control={control}
            setValue={setValue}
            watch={watch}
            required={false}
            accept=".pdf,.doc,.xls,.png,.jpeg,.csv"
          />
        ),
      },
      {
        key: "baixar-despesa",
        titulo: `Baixa da 1ª parcela`,
        icon: <FaFileInvoiceDollar size={20} />,
        conteudo: <SecaoBaixaContaPrincipal />,
      },
    ];

    return (
      <FormProvider {...form}>
        <AccordionDespesa keyItemAtivoPorPadrao="dados-despesa" itens={itensAccordion} permitirVariosItensAtivos />
      </FormProvider>
    );
  };

  return (
    <CustomModal
      key={"modal-cadastrar-despesa-parcelada-group-pay"}
      titulo="Incluir contas a pagar"
      size="xl"
      tipoModal="MODAL_LATERAL"
      bodyClassName="p-0"
      fecharModalAoClicarFora={!formState.isDirty}
      scrollable
      customFooter={
        <div>
          <CustomButton
            id="btn-cancelar-cadastrar-despesa-parcelada"
            label="Cancelar"
            onClick={handleCloseModal}
            variant="danger-alt"
            className="me-3"
            leftIcon={FaX}
          />
          <CustomButton id="btn-salvar-despesa-parcelada" label="Salvar" onClick={onSubmit} variant="primary" />
        </div>
      }
      onCloseModal={handleCloseModal}
      showModal={props.showModal}
    >
      <div className="p-4 pb-0">{renderContentModalCadastrarDespesaParcelada()}</div>
    </CustomModal>
  );
};

export default ModalCadastrarDespesaParceladaGroupPay;
